<template>
  <div class="report_wrapper month" ref="alerts">
    <listTime :listValue="plugValue" @listVisible="clickVisible" :currentTime="currentTime"></listTime>

    <div v-show="datashow">
      <!-- 心率 -->
      <monthHeartrate :sendTime="currentTime" @heareatcode="hasheareat"></monthHeartrate>
      <!-- 血压 -->
      <monthBlood :sendTime="currentTime" @bloodcode="hasbloodpre"></monthBlood>
      <!-- 血糖 -->
      <monthSugar
        v-if="$route.params.appName=='wsjk'":sendTime="currentTime" @sugarcode="hassugar"></monthSugar>
      <!-- 血氧 -->
      <monthOxygen :sendTime="currentTime" @oxygencode="hasoxygen"></monthOxygen>
      <!-- 体温 -->
      <monthTemperature :sendTime="currentTime" @tempcode="hastemp"></monthTemperature>
       <!-- 呼吸 -->
      <monthBreathe  :sendTime="currentTime" @breathcode="hasbreath"></monthBreathe>
      <!-- 脏腑 -->
      <monthViscera :sendTime="currentTime" @viceracode="hasvis"></monthViscera>
      <!-- 营养元素 -->
      <!-- <monthNutrition :sendTime="currentTime" @elementcode="hasele"></monthNutrition> -->
      <!-- 心肺 -->
      <monthCardiopulmonary
        v-if="$route.params.appName=='wsjk'"
        :sendTime="currentTime"
        @cdplycode="hascsby"
      ></monthCardiopulmonary>
      <!-- 睡眠 -->
      <monthSleep :sendTime="currentTime" @sleepcode="hassleep"></monthSleep>
      <!-- 疲劳 -->
      <monthFat v-if="$route.params.appName=='wsjk'" :sendTime="currentTime" @fatcode="hasfat"></monthFat>
      <!-- 运动管理-->
      <monthSteps :sendTime="currentTime" @stepcode="hassteps"></monthSteps>
      <!-- 呼吸 -->
       <!-- <monthBreathe  v-if="$route.params.appName=='smjh'" :sendTime="currentTime" @breathcode="hasbreath"></monthBreathe>-->
     
    </div>
    <div v-show="!datashow">
      <no-data @openPicker="clickVisible" :sendNavtype="navtype"></no-data>
    </div>
  </div>
</template>
<script>
import listTime from "../common/components/mixins/listTimeShow";
import { bus } from "../../main.js";
import noData from "../common/components/noData";
import monthBlood from "./components/monthBlood";
import monthCardiopulmonary from "./components/monthCardiopulmonary";
import monthHeartrate from "./components/monthHeartrate";
import monthOxygen from "./components/monthOxygen";
import monthSleep from "./components/monthSleep";
import monthSteps from "./components/monthSteps";
import monthSugar from "./components/monthSugar";
import monthTemperature from "./components/monthTemperature";
import monthViscera from "./components/monthViscera";
import monthFat from "./components/monthFat";
import monthNutrition from "./components/monthNutrition";

import monthBreathe from "./components/monthBreathe";
export default {
  name: "MonthData",
  data() {
    return {
      navtype: "月",
      currentTime: "",
      dialogTableVisible: false,
      bldData: true,
      carpyData: true,
      fatData: true,
      hrateData: true,
      oygData: true,
      slepData: true,
      stepData: true,
      sugData: true,
      tempData: true,
      visData: true,
      breatheDate: true,
      elemtData:true,
      msg: "",
      plugValue: {
        listType: "月",
        reportList: [],
        hasList: false,
        type: "month",
        title: this.$t("components.reportList"),
        nodata: this.$t("components.zanwu"),
        reset: this.$t("components.quxiao"),
        sub: this.$t("components.queding")
      },
      appType: {
        appName: this.$route.params.appName
      }
    };
  },
  computed: {
    datashow: function() {
      // 如果全部为false成立
      if (this.$route.params.appName === "wsjk") {
        return !(
          !this.bldData &&
          !this.carpyData &&
          !this.fatData &&
          !this.hrateData &&
          !this.oygData &&
          !this.slepData &&
          !this.stepData &&
          !this.sugData &&
          !this.tempData &&
          !this.visData&&
          !this.elemtData
        );
      } else {
        return !(
          !this.bldData &&
          !this.hrateData &&
          !this.oygData &&
          !this.slepData &&
          !this.stepData &&
          !this.tempData &&
          !this.visData &&
          !this.breatheDate
        );
      }
    }
    // })
  },
  mounted() {
    this.getReportListInfo();
    bus.$emit("defaultDate", this.currentTime);
  },
  methods: {
    getCurrentTime() {
      // 接收列表中选择的日期
      let _this = this;
      bus.$on("currentMhVal", data => {
        _this.currentTime = data;
        //console.log('monthdata：' + data)
      });
    },
    getReportListInfo() {
      let postdata = {
        userid: this.$route.params.userID,
        friendid: this.$route.params.friendID
      };
      this.$axios.getMonthdefault(this.appType,postdata).then(this.getReportListInfoSucc);
    },
    getReportListInfoSucc(res) {
      if (res.code === 0 && res.data) {
        this.currentTime = res.data;
        this.getList();
      }
    },
    getList() {
      let postdata = {
        userid: this.$route.params.userID,
        friendid: this.$route.params.friendID,
        token: this.$route.params.token
      };
      this.$axios.getMonthlist(this.appType,postdata).then(res => {
        if (res.code === 0 && res.data) {
          this.plugValue.reportList = res.data;
        } else {
          this.msg = res.message;
          this.plugValue.hasList = true;
        }
      });
    },
    clickVisible() {
      // 点击读取月报列表
      this.$alertPl.show({
        el: this.$refs.alerts,
        title: "",
        comp: "listPlug",
        plugVal: this.plugValue
      });
      this.getCurrentTime();
    },
    hasheareat(obj) {
      if (obj.code === 999) {
        this.hrateData = false;
      } else if (obj.code === 0) {
        this.hrateData = true;
      }
      //console.log('心率：' + obj.code)
      // this.currentWeek = obj.time
    },
    hasbloodpre(obj) {
      if (obj.code === 999) {
        this.bldData = false;
      } else if (obj.code === 0) {
        this.bldData = true;
      }
      //console.log('血压：' + obj.code)
      // this.currentWeek = obj.time
    },
    hassugar(obj) {
      if (obj.code === 999) {
        this.sugData = false;
      } else if (obj.code === 0) {
        this.sugData = true;
      }
      //console.log('血糖：' + obj.code)
      // this.currentWeek = obj.time
    },
    hasoxygen(obj) {
      if (obj.code === 999) {
        this.oygData = false;
      } else if (obj.code === 0) {
        this.oygData = true;
      }
      //console.log('血样：' + obj.code)
      // this.currentWeek = obj.time
    },

    hastemp(obj) {
      if (obj.code === 999) {
        this.tempData = false;
      } else if (obj.code === 0) {
        this.tempData = true;
      }
      //console.log('体温：' + obj.code)
      // this.currentWeek = obj.time
    },

    hasvis(obj) {
      if (obj.code === 999) {
        this.visData = false;
      } else if (obj.code === 0) {
        this.visData = true;
      }
    },
    hasele(obj) {
      if (obj.code === 999) {
        this.elemtData = false;
      } else if (obj.code === 0) {
        this.elemtData = true;
      }
    },
    hascsby(obj) {
      if (obj.code === 999) {
        this.carpyData = false;
      } else if (obj.code === 0) {
        this.carpyData = true;
      }
      //console.log('心肺：' + obj.code)
      // this.currentWeek = obj.time
    },

    hassleep(obj) {
      if (obj.code === 999) {
        this.slepData = false;
      } else if (obj.code === 0) {
        this.slepData = true;
      }
      //console.log('睡眠：' + obj.code)
      // this.currentWeek = obj.time
    },

    hasfat(obj) {
      if (obj.code === 999) {
        this.fatData = false;
      } else if (obj.code === 0) {
        this.fatData = true;
      }
      //console.log('疲劳：' + obj.code)
      // this.currentWeek = obj.time
    },
    hassteps(obj) {
      if (obj.code === 999) {
        this.stepData = false;
      } else if (obj.code === 0) {
        this.stepData = true;
      }
      //console.log('步数：' + obj.code)
      // this.currentWeek = obj.time
    },
    hasbreath(obj) {
      if (obj.code === 999) {
        this.breatheDate = false;
      } else if (obj.code === 0) {
        this.breatheDate = true;
      }
    }
  },
  components: {
    listTime,
    monthHeartrate,
    monthBlood,
    monthCardiopulmonary,
    monthOxygen,
    monthSleep,
    monthSteps,
    monthSugar,
    monthTemperature,
    monthViscera,
    monthFat,
    noData,
    monthBreathe,
    monthNutrition
  }
};
</script>
<style lang="stylus" scoped>































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































// @import '~styles/alertPlugin.styl'































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































</style>



// WEBPACK FOOTER //
// src/pages/month-data/MonthData.vue